import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "message-timestamp"
};
import { toRefs, ref, watch } from "../../../../adapter-vue";
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
export default /*@__PURE__*/_defineComponent({
  __name: 'message-timestamp',
  props: {
    currTime: {
      type: Number,
      "default": 0
    },
    prevTime: {
      type: Number,
      "default": 0
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _toRefs = toRefs(props),
      currTime = _toRefs.currTime,
      prevTime = _toRefs.prevTime;
    var timestampShowFlag = ref(false);
    var timestampShowContent = ref("");
    var handleItemTime = function handleItemTime(currTime, prevTime) {
      timestampShowFlag.value = false;
      if (currTime <= 0) {
        return "";
      } else if (!prevTime || prevTime <= 0) {
        timestampShowFlag.value = true;
        return calculateTimestamp(currTime * 1000);
      } else {
        var minDiffToShow = 10 * 60; //10min 10*60s
        var diff = currTime - prevTime; //s
        if (diff >= minDiffToShow) {
          timestampShowFlag.value = true;
          return calculateTimestamp(currTime * 1000);
        }
      }
      return "";
    };
    var t = function t() {
      return TUITranslateService.t();
    };
    watch(function () {
      return [currTime.value, prevTime.value];
    }, function (newVal, oldVal) {
      if ((newVal === null || newVal === void 0 ? void 0 : newVal.toString()) === (oldVal === null || oldVal === void 0 ? void 0 : oldVal.toString())) {
        return;
      } else {
        timestampShowContent.value = handleItemTime(currTime.value, prevTime.value);
      }
    }, {
      immediate: true
    });
    // 计算时间戳函数
    // calculate timestamp
    function calculateTimestamp(timestamp) {
      var todayZero = new Date().setHours(0, 0, 0, 0);
      var thisYear = new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0).getTime();
      var target = new Date(timestamp);
      var oneDay = 24 * 60 * 60 * 1000;
      var oneWeek = 7 * oneDay;
      var oneYear = 365 * oneDay;
      var diff = todayZero - target.getTime();
      function formatNum(num) {
        return num < 10 ? "0" + num : num.toString();
      }
      if (diff <= 0) {
        // today, only display hour:minute
        return "".concat(formatNum(target.getHours()), ":").concat(formatNum(target.getMinutes()));
      } else if (diff <= oneDay) {
        // yesterday, display yesterday:hour:minute
        return "".concat(TUITranslateService.t("time.昨天"), " ").concat(formatNum(target.getHours()), ":").concat(formatNum(target.getMinutes()));
      } else if (diff <= oneWeek - oneDay) {
        // Within a week, display weekday hour:minute
        var weekdays = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
        var weekday = weekdays[target.getDay()];
        return "".concat(TUITranslateService.t("time." + weekday), " ").concat(formatNum(target.getHours()), ":").concat(formatNum(target.getMinutes()));
      } else if (target.getTime() >= thisYear) {
        // Over a week, within this year, display mouth/day hour:minute
        return "".concat(target.getMonth() + 1, "/").concat(target.getDate(), " ").concat(formatNum(target.getHours()), ":").concat(formatNum(target.getMinutes()));
      } else {
        // Not within this year, display year/mouth/day hour:minute
        return "".concat(target.getFullYear(), "/").concat(target.getMonth() + 1, "/").concat(target.getDate(), " ").concat(formatNum(target.getHours()), ":").concat(formatNum(target.getMinutes()));
      }
    }
    return function (_ctx, _cache) {
      return _unref(timestampShowFlag) ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(timestampShowContent)), 1)) : _createCommentVNode("", true);
    };
  }
});